import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List, Set} from 'immutable';
import {default as Facets, FacetItem} from 'components/Facets';

export default createReactClass({
  propTypes: {
    typefaces: ImmutablePropTypes.list,
    workingSetTypefaces: ImmutablePropTypes.list,
  },

  mixins: [ImmutableRenderMixin],

  render() {
    const {typefaces, workingSetTypefaces} = this.props;
    const includedTypefaceIds = workingSetTypefaces
      .map((workingSetTypeface) => workingSetTypeface.typeface);
    const families = typefaces
      .groupBy((typeface) => typeface.family);
    const groupCounts = families
      .map((typefacesByFamily, family) => {
        return typefacesByFamily.size;
      });
    const groupedFamilies = List(families.keys()).groupBy((family) => {
      const intersection = Set(families.get(family).map((i) => i.id))
        .intersect(includedTypefaceIds);
      return intersection.isEmpty() ? 'available' : 'included';
    });
    const facetItems = groupedFamilies.map((familiesByStatus, status) => {
      return familiesByStatus.map((family) => {
        return FacetItem({label: family, count: groupCounts.get(family)});
      });
    });

    return (
      <Facets heading="Typefaces" groups={facetItems}/>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefaceFacets.js